@if (content.isMembership) {
<div class="purchase-options">
  <!-- <div *ngIf="checkout.error">
    <aura-error-message [content]="checkout.error"></aura-error-message>
  </div> -->
  <!-- Moved the error message to top of the page -->
  <aura-divider [type]="'light'"></aura-divider>
  <form>
    <section>
      @for (option of content.options; track $index) {
      <section>
        <fieldset class="purchase-options__section">
          <legend class="purchase-options__title">
            {{ option.type.title }}
            <div class="purchase-options__subtitle">
              {{ option.type.subtitle }}
              {{ option.type.content }}
            </div>
          </legend>
          <div class="purchase-options__radio-button-wrapper">
            @for (currency of option.currencies; track currency.value; let i = $index) {
            <div class="purchase-options__alignment">
              <input
                auraRadio
                type="radio"
                [name]="option.type.title.toLowerCase().replace(' ', '_')"
                [id]="'radio-' + option.membershipDetails[i].objectIndex"
                #item
                [value]="currency.value"
                (click)="selectOptions(item.value, option.membershipDetails[i])"
                auraRadioColor="primary"
              />
              <label
                [for]="'radio-' + option.membershipDetails[i].objectIndex"
                class="aura-radio-label"
              >
                {{ currency.value }} {{ currency.label }}
              </label>
            </div>
            }
          </div>
          <aura-divider [type]="'light'"></aura-divider>
        </fieldset>
      </section>
      }
      <aura-divider [type]="'light'"></aura-divider>

      <section class="purchase-options__total">
        @if (!membership.selected) {
        <div class="purchase-options__details">
          {{ content.total.title }}{{ content.total.subtitle }}
        </div>
        } @if (membership.selected) {
        <div class="purchase-options__details">
          {{ content.total.title }}{{ membership.value }}
        </div>
        }
      </section>

      <section class="purchase-options__action">
        <button
          auraButton
          [buttonSize]="'small'"
          [buttonColor]="'primary'"
          [buttonOutlineColor]="'primary'"
          [buttonDisabled]="!membership.selected"
          class="purchase-options__aura"
          [id]="content.action.id"
          (click)="onAddToCartClick()"
          type="button"
        >
          {{ content.action.label }}
        </button>
      </section>
    </section>
  </form>
</div>
}
